import { Typography } from 'shared/ui'
import { type IResponseUserTeamRole } from 'entities/Users/api/types'
import styles from './styles.module.scss'

type IPermissionChip = {
  permission: IResponseUserTeamRole
}

export const PermissionChip = ({ permission }: IPermissionChip) => {
  return (
    <div className={styles.wrap}>
      <Typography variant='body-md-regular' ariaLabel='member-permission'>
        {permission === 'owner' ? 'Owner' : 'Member'}
      </Typography>
    </div>
  )
}
